// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  AddListPage,
  PositionTypePage,
  CompanyTypePage,
  AreaPage,
  BenefitsPage,
  CertTypePage,
  EduPage,
  UserTagPage,
  SalaryRangePage,
  SalaryTypePage,
  IndustryTypePage,
  WorkExperiencePage,
  PositionCategory,
} from './';

export default {
  path: 'system',
  name: 'System',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'addList', name: 'Add list page', component: AddListPage },
    { path: 'positiontype', name: 'positiontype page', component: PositionTypePage },
    { path: 'companytype', name: 'companytype page', component: CompanyTypePage },
    { path: 'area', name: 'companytype page', component: AreaPage },
    { path: 'benefits', name: 'companytype page', component: BenefitsPage },
    { path: 'certtype', name: 'companytype page', component: CertTypePage },
    { path: 'edu', name: 'companytype page', component: EduPage },
    { path: 'usertag', name: 'companytype page', component: UserTagPage },
    { path: 'salaryrange', name: 'companytype page', component: SalaryRangePage },
    { path: 'salarytype', name: 'companytype page', component: SalaryTypePage },
    { path: 'workexperience', name: 'companytype page', component: WorkExperiencePage },
    { path: 'industry', name: 'companytype page', component: IndustryTypePage },
    { path: '/system/position/category', name: 'Position category', component: PositionCategory },
  ],
};



// WEBPACK FOOTER //
// ./src/features/system/route.js